// extracted by mini-css-extract-plugin
export default {"scrollRef":"vpm41p"};